import langJa from "./ja"
import langEn from "./en"

export default {
  en: {translation: langEn},
  ja: {translation: langJa}
}
